/**
 * Created by brad on 3/28/16.
 */

import { Model } from 'backbone';

class AssetModel extends Model {

    initialize() {

        this.set('assetId', this.get('id'), {silent:true});

        if (this.get('mimeType') === '' && this.get('type') === 'image') {
            this.set('mimeType', 'image/jpeg', {silent:true});
        }
    }


    defaults() {
        const def = {};
        def.assetId = '';
        def.name = '';
        def.type = '';
        def.mimeType = '';
        def.factoryKey = 'asset';

        return def;
    }


}

export default AssetModel;